export const CARD_PLACEHOLDER = '-';
